import type {
  UiTypographyAlignType,
  UiTypographyColorType,
  UiTypographyDecorationType,
  UiTypographyStyleType,
  UiTypographyTransformType,
  UiTypographyVariantType,
} from './types';

export const uiTypographyClassNames = {
  get root(): string {
    return 'ui-typography';
  },

  color(color: UiTypographyColorType[number] | null): string {
    return `ui-typography--color-${color}`;
  },

  variant(variant: UiTypographyVariantType[number]): string {
    return `ui-typography--variant-${variant}`;
  },

  transform(transform: UiTypographyTransformType[number]): string {
    return `ui-typography--transform-${transform}`;
  },

  align(align: UiTypographyAlignType[number]): string {
    return `ui-typography--align-${align}`;
  },

  decoration(decoration: UiTypographyDecorationType[number]): string {
    return `ui-typography--decoration-${decoration}`;
  },

  fontStyle(fontStyle: UiTypographyStyleType[number]): string {
    return `ui-typography--font-style-${fontStyle}`;
  },
};
